// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Edit = function Edit(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1.696 11.43l8.887-8.89 2.848 2.847-8.888 8.89zM.767 15.274l3.128-.409-2.719-2.719-.409 3.128zM12.987.844a.5.5 0 00-.707 0L11.219 1.9l2.848 2.847 1.062-1.057a.5.5 0 000-.707z"
    }))
  );
};

export default Edit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Edit.js
// module id = 1002
// module chunks = 0